import { ChevronDownIcon } from "./icons";

const TermsConditionsSection = ({ expandedDays, setExpandedDays }) => {
  return (
    <div className="bg-white rounded-2xl shadow-sm mb-8 overflow-hidden">
      <button
        onClick={() => setExpandedDays(prev => ({ ...prev, terms: !prev.terms }))}
        className="w-full flex items-center justify-between p-6 text-left cursor-pointer transition-all duration-300 ease-in-out hover:bg-gray-50"
      >
        <h2 className="text-lg font-semibold text-gray-900">Terms & Conditions</h2>
        <ChevronDownIcon className={`w-5 h-5 text-gray-500 transition-transform duration-300 ease-in-out ${
          expandedDays.terms ? 'rotate-180' : ''
        }`} />
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          expandedDays.terms ? 'max-h-[400px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-6 pb-6 text-gray-600 text-sm leading-relaxed border-t border-gray-100 pt-4">
          <ul className="list-disc list-inside space-y-2">
            <li>Rates are subject to availability at the time of booking</li>
            <li>Hotel check-in and check-out times vary by location - please confirm with your hotel</li>
            <li>Valid government-issued ID proof required at all hotels</li>
            <li>Itinerary may be modified based on local conditions, weather, or unforeseen circumstances</li>
            <li>Cancellation charges apply as per individual hotel and service provider policies</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TermsConditionsSection;
